<script setup>
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import TemplatesPicker from './ContentTemplatesPicker.vue';
import TemplateParser from '../../../../components-next/content-templates/ContentTemplateParser.vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  inboxId: {
    type: Number,
    default: undefined,
  },
});

const emit = defineEmits(['onSend', 'cancel']);

const { t } = useI18n();

const dialogRef = ref(null);
const selectedContentTemplate = ref(null);

const modalHeaderContent = computed(() => {
  return selectedContentTemplate.value
    ? t('CONTENT_TEMPLATES.MODAL.TEMPLATE_SELECTED_SUBTITLE', {
        templateName: selectedContentTemplate.value.friendly_name,
      })
    : t('CONTENT_TEMPLATES.MODAL.SUBTITLE');
});

onMounted(() => {
  dialogRef.value?.open();
});

const pickTemplate = template => {
  selectedContentTemplate.value = template;
};

const onResetTemplate = () => {
  selectedContentTemplate.value = null;
};

const onSendMessage = message => {
  emit('onSend', message);
};

const onClose = () => {
  emit('cancel');
};
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="2xl"
    overflow-y-auto
    :title="$t('CONTENT_TEMPLATES.MODAL.TITLE')"
    :description="modalHeaderContent"
    :show-cancel-button="false"
    :show-confirm-button="false"
    @close="onClose"
  >
    <TemplatesPicker
      v-if="!selectedContentTemplate"
      :inbox-id="inboxId"
      @on-select="pickTemplate"
    />
    <TemplateParser
      v-else
      :template="selectedContentTemplate"
      @reset-template="onResetTemplate"
      @send-message="onSendMessage"
    >
      <template #actions="{ sendMessage, resetTemplate, disabled }">
        <div class="flex gap-2 mt-6">
          <Button
            :label="t('CONTENT_TEMPLATES.PARSER.GO_BACK_LABEL')"
            color="slate"
            variant="faded"
            type="button"
            class="flex-1"
            @click="resetTemplate"
          />
          <Button
            :label="t('CONTENT_TEMPLATES.PARSER.SEND_MESSAGE_LABEL')"
            class="flex-1"
            type="button"
            :disabled="disabled"
            @click="sendMessage"
          />
        </div>
      </template>
    </TemplateParser>
    <template #footer />
  </Dialog>
</template>
